import './social-network-qualification.ajscss';

import { ISocialNetworkFrameService } from '@agent/agent-interface/contact-view/social-network/services/social-network-frame.service';
import { IQualificationDeprecatedService } from '@agent/core/contact/qualification-deprecated.service';
import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './social-network-qualification.template.html';

const MODULE_NAME = 'socialNetworkQualification';

class SocialNetworkQualificationCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;
  canFinishQualification = false;

  constructor(
    private readonly qualificationDeprecatedService: IQualificationDeprecatedService,
    private readonly socialNetworkFrameService: ISocialNetworkFrameService
  ) {}

  $onInit(): void {
    if (!this.responseId && this.socialNetworkFrameService.activeSocialNetwork) {
      this.responseId = this.socialNetworkFrameService.activeSocialNetwork.responseId;
    }
    if (!this.responseId) {
      throw Error('no responseId');
    }
    // TODO remove this part, it's useless
    this.qualificationDeprecatedService
      .canFinishQualification(this.responseId)
      .then(canFinish => (this.canFinishQualification = canFinish));
  }
}

export class SocialNetworkQualification implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = ['qualificationDeprecatedService', 'socialNetworkFrameService', SocialNetworkQualificationCtrl];
}

export default MODULE_NAME;
